<script lang="ts">
  import { transformListKey } from '$shared/helpers/ListKeyFormat';
  import { isNoLableKey, parseDynamicData } from '$shared/helpers/utils';
  import type { IDataList } from 'src/global';

  interface Props {
    value?: IDataList[];
  }

  let { value = [] }: Props = $props();
</script>

<div data-cy="board-certificate" class="certificate-container">
  {#each value as val, index}
    {#each Object.entries(val) as [key, data]}
      <!-- content here -->
      <div class="certificate-li" class:odd={(index + 1) % 2 !== 0}>
        {#if !isNoLableKey(key)}
          <div data-cy={`${key}-k`} class="key">{transformListKey(key)}</div>
        {/if}
        {#if data?.component}
          {@const SvelteComponent = data?.component}
          <div class="complex-value">
            <SvelteComponent {...data?.props} />
          </div>
        {:else}
          <div data-cy={`${key}-v`} class="value">{parseDynamicData(data)}</div>
        {/if}
      </div>
    {/each}
  {:else}
    empty list
  {/each}
</div>

<style>
  .certificate-li {
    display: flex;
    align-items: flex-start;
    padding: 12px 16px;
    line-height: 20px;
    color: var(--grey-dark);
  }
  .certificate-li.odd {
    background-color: var(--grey-bg) !important;
  }
  .certificate-li .key {
    width: 150px;
    flex-shrink: 0;
    margin-right: 16px;
    overflow: hidden;
    color: var(--black);
    font-weight: 500;
  }
  .certificate-li .value,
  .certificate-li .complex-value {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .certificate-li .complex-value {
    margin-top: -12px;
    margin-left: -16px;
  }
</style>
